import React from "react";

export function PortsideStripe() {
  return <div className="portside-stripe" data-testid="portside-stripe" />;
}

export function PortsideMark() {
  // Stylized wordmark — italic lowercase navy "portside"
  return (
    <span className="portside-wordmark" data-testid="portside-wordmark">
      portside
    </span>
  );
}
